import { Button, Heading, Icon, IconButton, Select, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { useState } from "react";

import { FaArrowLeft, FaArrowRight, FaColumns, FaDownload, FaHubspot, FaLink, FaSync } from "react-icons/fa";

import { RiFilterOffFill } from "react-icons/ri";

export default function HubspotSync() {
    const [invs] = useState([
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
        {
            externalId: 0,
            firstName: "Hamza",
            lastName: "Akram",
            email: 'stdhamza26@gmail.com',
            createdDate: "01-Jan-1 04:28",
            lineSource: "EB",
            updatedDate: '01-Jan-1 04:28',
            ebUserId: 116633,
            orgRole: 'One Account Owner',
            orgId: 6520
        },
    ]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                align={'center'}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={FaHubspot}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Hubspot Sync</Heading>
                            <Text fontSize={'sm'}>Hubspot for users and company data.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack align={{ lg: 'flex-start', xl: 'flex-end' }} justify={'end'} spacing={4}>
                    <Stack direction={'row'}>
                        <Button
                            size={'sm'}
                            leftIcon={<FaDownload />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Delete Org
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaDownload />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Get Data
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaLink />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Send Data
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaSync />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Refresh
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<FaColumns />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Columns
                        </Button>
                        <Button
                            size={'sm'}
                            leftIcon={<RiFilterOffFill />}
                            color={'white'}
                            bg={'primary.400'}
                            _hover={{ bg: 'primary.600' }}
                            _active={{ bg: 'primary.700' }}
                        >
                            Clear Filter
                        </Button>
                    </Stack>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    External ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    First Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Last Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Created Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Line Source
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Updated Date
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    EB User ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Organization Role
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org ID
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.map((inv, i) => (
                                    <Tr>
                                        <Td>{inv.externalId}</Td>
                                        <Td>{inv.firstName}</Td>
                                        <Td>{inv.lastName}</Td>
                                        <Td>{inv.email}</Td>
                                        <Td>{inv.createdDate}</Td>
                                        <Td>{inv.lineSource}</Td>
                                        <Td>{inv.updatedDate}</Td>
                                        <Td>{inv.ebUserId}</Td>
                                        <Td>{inv.orgRole}</Td>
                                        <Td>{inv.orgId}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}